<p-drawer
  [modal]="false"
  class="sidebar"
  [(visible)]="opened"
  position="left"
  [showCloseIcon]="false"
  [closeOnEscape]="false"
>
  <ng-template #headless>
    <ng-template [ngTemplateOutlet]="sidebarContent" />
  </ng-template>
</p-drawer>

@if (!opened()) {
  <ng-template [ngTemplateOutlet]="sidebarContent" />
}

<ng-template #sidebarContent>
  <div
    [class.sidebar-content]="opened()"
    [class.sidebar-fixed]="!opened()"
    attr.data-testid="{{ opened() ? '' : 'sidebar-fixed' }}"
    (click)="opened() ? null : opened.set(true)"
  >
    <div class="header">
      @if (opened()) {
        <div class="logo-version">
          <app-icon class="logo-symbol" src="verisure-logo.svg" />
          <div class="logo-text">
            <app-icon class="logo-wording" src="verisure-wording.svg" />
            <div class="version" data-testid="version">{{ version }}</div>
          </div>
        </div>
      }
      <app-icon
        class="collapse"
        src="sidebar.svg"
        (click)="opened.set(!opened())"
      />
    </div>
    <ul class="options">
      @for (option of options(); track option.route) {
        <li
          class="option"
          routerLinkActive="active"
          [routerLink]="option.route"
          [routerLinkActiveOptions]="{ exact: true }"
          [class.hidden]="!showOptions()"
          attr.data-testid="side-bar__options__{{ option.testId }}"
          [pTooltip]="opened() ? '' : (option.title | translate)"
          tooltipStyleClass="sidebar-tooltip"
          (click)="$event.stopPropagation(); $event.preventDefault()"
        >
          <app-icon icon="pi {{ option.icon }}" />
          @if (opened()) {
            <span>{{ option.title | translate }}</span>
          }
        </li>
      }
    </ul>
    @if (!opened()) {
      <ng-template [ngTemplateOutlet]="bottom" />
    }
  </div>
  @if (opened()) {
    <ng-template [ngTemplateOutlet]="bottom" />
  }
</ng-template>

<ng-template #bottom>
  <div class="user-logout" [class.open]="opened()">
    <div class="user-full">
      <div class="user-avatar">{{ enhancedUser().initials }}</div>
      @if (opened()) {
        <div class="user-info">
          <span class="user-name user-line">{{ enhancedUser()?.name }}</span>
          <span class="user-id user-line">{{
            enhancedUser()?.employeeId
          }}</span>
          <span class="user-role user-line"
            >{{ enhancedUser().countryEmoji }}
            {{ enhancedUser()?.cleanRoles }}</span
          >
        </div>
      }
    </div>
    <button data-testid="log-out" class="logout" (click)="logout($event)">
      <app-icon
        class="logout-icon"
        icon="pi pi-sign-out"
        [pTooltip]="opened() ? '' : ('Globals.Logout' | translate)"
        tooltipStyleClass="sidebar-tooltip"
      />
      @if (opened()) {
        <span>{{ 'Globals.Logout' | translate }}</span>
      }
    </button>
  </div>
</ng-template>
